import React, { useEffect, useState } from "react";
import { listEvents, deleteEvent, withBase } from "./api";
import styles from "./List.module.css";

const stripHtml = (html = "") => html.replace(/<[^>]+>/g, "").trim();
const truncate = (text = "", length = 100) =>
  text.length <= length ? text : `${text.slice(0, length).replace(/\s+$/g, "")}...`;

const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' });
};

export default function EventsList() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [busyId, setBusyId] = useState(null);

  useEffect(() => {
    listEvents()
      .then((res) => setItems(res.items || []))
      .catch((e) => setError(e.message || "Failed to load"));
  }, []);

  return (
    <div className={styles.card}>
      <div className={styles.headerRow}>
        <div className={styles.title}>Upcoming Events</div>
      </div>
      {error && <div className={styles.empty}>{error}</div>}
      <div className={styles.tableWrap}>
        <table className={styles.table}>
        <thead className={styles.thead}>
          <tr>
            <th className={styles.th}>#</th>
            <th className={styles.th}>Event Title</th>
            <th className={styles.th}>Description</th>
            <th className={styles.th}>Venue</th>
            <th className={styles.th}>Place</th>
            <th className={styles.th}>Date</th>
            <th className={styles.th}>Image</th>
            <th className={styles.th}>Action</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td className={styles.empty} colSpan={8}>No events found.</td>
            </tr>
          ) : (
            items.map((it, idx) => (
              <tr key={it.id}>
                <td className={styles.td}>{idx + 1}</td>
                <td className={styles.td}>{it.title}</td>
                <td className={`${styles.td} ${styles.contentCell}`}>
                  {truncate(stripHtml(it.description), 80)}
                </td>
                <td className={styles.td}>{it.venue}</td>
                <td className={styles.td}>{it.place}</td>
                <td className={styles.td}>{formatDate(it.event_date)}</td>
                <td className={styles.td}>
                  {it.image_path ? (
                    <div style={{width: '80px', height: '60px', borderRadius: '6px', overflow: 'hidden', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <img className={styles.img} src={withBase(it.image_path)} alt="event" />
                    </div>
                  ) : (
                    <span style={{color: '#999'}}>No image</span>
                  )}
                </td>
                <td className={styles.td}>
                  <div className={styles.actions}>
                    <button className={`${styles.btn} ${styles.btnEdit}`} onClick={()=>{
                      const params = new URLSearchParams({ id: String(it.id) });
                      window.location.href = `/admin/events/add?${params.toString()}`;
                    }}>Edit</button>
                    <button className={`${styles.btn} ${styles.btnDelete}`} disabled={busyId===it.id} onClick={async()=>{
                      setBusyId(it.id);
                      try { 
                        await deleteEvent(it.id); 
                        setItems(items.filter(x=>x.id!==it.id)); 
                      }
                      catch(e){ setError(e.message||'Delete failed'); }
                      finally{ setBusyId(null); }
                    }}>Delete</button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
}
